import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

export default function BillingCancel() {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <NavBar />
      <div className="max-w-xl mx-auto px-5 lg:px-10 py-24 text-center">
        <span className="sticker sticker-magenta mb-3 inline-block">No charge</span>
        <h1 className="font-display text-5xl font-extrabold leading-[0.92] tracking-tight mb-4 mt-3">
          You bounced. <span className="text-rainbow">All good.</span>
        </h1>
        <p className="text-base text-[#0B0F0C]/70 mb-8">No card was charged. Come back when you're ready.</p>
        <Link to="/billing" className="btn-x btn-primary"><ArrowLeft size={14} strokeWidth={2.4} /> Back to billing</Link>
      </div>
      <Footer />
    </div>
  );
}
